import styled from 'styled-components'

export const LabelWrap = styled.div`
  display: flex;
  margin-bottom: 6px;

  & span {
    line-height: 17px;
    margin: 0;
  }
`

export const TemplatesHintButton = styled.div`
  display: flex;
  margin-left: auto;

  & button {
    height: 17px;
    padding: 0;
    width: 116px;
  }
`

export const EditorWrap = styled.div`
  min-height: 100px;
`
